import React from "react";
import Dialog from "material-ui/Dialog";
import RaisedButton from "material-ui/RaisedButton";
import firebase from "../../../lib/firebase";
import store from "../../../lib/store";
import Setting from "./Setting";

/**
 * Dialog content can be scrollable.
 */
export default class SettingDialog extends React.Component {
    state = {
        open: false,
    };

    handleOpen = () => {
        if(firebase.auth().currentUser === null){
            store.dispatch({
                type:'LOGIN',
                loginOpen:true,
                loginAfterExecute:function(){
                    this.setState({open: true});
                }.bind(this)
            });
        } else {
            this.setState({open: true});
        }

    };

    handleClose = () => {
        this.setState({open: false});
    };

    render() {

        return (
            <div>
                <RaisedButton label="예" onTouchTap={this.handleOpen} />
                <Dialog
                    modal={false}
                    open={this.state.open}
                    onRequestClose={this.handleClose}
                    autoScrollBodyContent={true}
                >
                    <Setting campaignId={this.props.campaignId} isNew={true}></Setting>
                </Dialog>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/container/campaign/component/SettingDialog.js